__turbopack_context__.v({
  "mochi-checkbox": "mochi-checkbox-module-scss-module__Gv3jfa__mochi-checkbox",
});
